import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLogin } from "@refinedev/core";
import { Loader2 } from "lucide-react";
import { useState } from "react";

export const description =
  "A login form with email and password. There's an option to login with Google and a link to sign up if you don't have an account.";

export function Login() {
  const { mutate: login, isPending, isSuccess, isError } = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div className="flex min-h-screen w-full flex-col bg-background/90 justify-center">
      <Card className="mx-auto max-w-sm p-8">
        <CardHeader>
          <CardTitle className="text-2xl">Login</CardTitle>
          <CardDescription>
            Enter your email below to login to your account
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="m@example.com"
                required
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="grid gap-2">
              <div className="flex items-center">
                <Label htmlFor="password">Password</Label>
                {/* <Link href="#" className="ml-auto inline-block text-sm underline">
                Forgot your password?
              </Link> */}
              </div>
              <Input
                id="password"
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                onKeyUp={(e) =>
                  e.key === "Enter" &&
                  login({ email, password, provider: "email" })
                }
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full"
              onClick={() =>
                login({
                  email,
                  password,
                  provider: "email",
                })
              }
              disabled={isPending || isSuccess}
            >
              {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {isPending ? "Loading..." : isSuccess ? "Logged in" : "Login"}
            </Button>
            <Button
              variant="outline"
              className="w-full"
              disabled={isPending || isSuccess}
              onClick={() =>
                login({
                  provider: "google",
                })
              }
            >
              {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {isPending
                ? "Loading..."
                : isSuccess
                ? "Logged in"
                : "Login with Google"}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
